import { types, getEnv } from 'mobx-state-tree';
import { logger } from './BaseModel';

export default types
  .model('BaseMSTModel')
  .views(self => {
    const context = getEnv(self);

    return {
      /**
       * @returns {Object}
       */
      get stores() {
        return context.stores;
      },

      /**
       * @returns {Function}
       */
      get api() {
        return context.api;
      },

      /**
       * @returns {Object}
       */
      get logger() {
        return logger;
      },
    };
  });
